module.exports = __webpack_public_path__ + "media/packs/src/assets/images/facebook-icon-2537ab009e5f45708084e17106db74b3.svg";